import { useEffect, useState, useCallback, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { fileUrl } from "@/lib/upload";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { Shell } from "./clientjob/Shell";
import { PropertyHeader } from "./clientjob/PropertyHeader";
import { GallerySection } from "./clientjob/GallerySection";
import { Lightbox } from "./clientjob/Lightbox";

export default function ClientJob() {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [missing, setMissing] = useState(false);
  const [lightbox, setLightbox] = useState(null);
  useEffect(() => { api.get(`/jobs/${id}`).then((r) => setJob(r.data)).catch(() => setMissing(true)); }, [id]);

  const download = useCallback((f) => {
    if (job.downloads_locked) { toast.error("Downloads unlock when this order is paid."); return; }
    const a = document.createElement("a"); a.href = fileUrl(job.id, f.id, false); a.download = f.original_filename; a.click();
  }, [job]);
  const openFile = (f) => (f.is_image ? setLightbox(f) : download(f));

  const p = job?.property || {};
  const cover = job?.files?.find((f) => f.id === job.cover_file_id && f.is_image);
  const images = useMemo(() => job?.files?.filter((file) => file.is_image) || [], [job]);
  const listingFacts = useMemo(() => [["Beds", p.beds], ["Baths", p.baths], ["Sq.ft", p.sqft], ["Lot", p.lot_size], ["Year built", p.year_built], ["List price", p.list_price]].filter(([, value]) => value), [p.beds, p.baths, p.sqft, p.lot_size, p.year_built, p.list_price]);

  if (missing) return <Shell><p className="text-slate-500">This job could not be found.</p></Shell>;
  if (!job) return <Shell><p className="text-slate-400">Loading…</p></Shell>;

  return (
    <Shell>
      <Link to="/dashboard" data-testid="job-back" className="inline-flex items-center gap-2 eyebrow hover:text-slate-900"><ArrowLeft className="h-3.5 w-3.5" /> My jobs</Link>
      {cover && <div className="mt-8 aspect-[21/9] overflow-hidden bg-slate-100"><img src={fileUrl(job.id, cover.id)} alt="" className="w-full h-full object-cover" /></div>}

      <PropertyHeader job={job} listingFacts={listingFacts} />

      <div className="mt-16 space-y-14">
        {job.galleries.map((gallery) => <GallerySection key={gallery.id} job={job} gallery={gallery} onOpenFile={openFile} />)}
        {job.files.length === 0 && !job.galleries.some((g) => g.external_url) && <p className="text-slate-400 border border-dashed border-slate-300 p-12 text-center">Your media will appear here once delivered.</p>}
      </div>

      {lightbox && <Lightbox job={job} images={images} file={lightbox} onChange={setLightbox} onClose={() => setLightbox(null)} onDownload={download} />}
    </Shell>
  );
}
